require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./galerie-marchande-les-arcades-1-1-18-0.json") })
        }
      }, "path---galerie-marchande-les-arcades-1-1-18-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---galerie-marchande-les-arcades-1-1-18-0!./.cache/json/galerie-marchande-les-arcades-1-1-18-0.json
// module id = 441
// module chunks = 231608221292675